import { render } from "./AdmissionBenefit.vue?vue&type=template&id=421421da&scoped=true"
import script from "./AdmissionBenefit.vue?vue&type=script&lang=js"
export * from "./AdmissionBenefit.vue?vue&type=script&lang=js"

import "./AdmissionBenefit.vue?vue&type=style&index=0&id=421421da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-421421da"]])

export default __exports__